import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { cn } from "@util/helpers";

type ChineseBannerProps = {
  /** The classname of the component. */
  className?: string;
  /** The URL path of the button. */
  urlPath: string;
};

/** This is the banner to be displayed in article pages in chinese language. */
const ChineseBanner = ({
  className,
  urlPath,
}: ChineseBannerProps): React.ReactElement => {
  const sendDataToGTM = useGTMDispatch();

  const handleClick = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "translation cta",
      eventAction: "click",
      eventLabel: "查看原文",
    });
  };

  return (
    <div
      data-testid="chinese-banner-component"
      data-section-name="translation cta"
      className={cn(
        "track-impression flex flex-wrap items-center justify-between gap-4 border-l-[3px] border-gray-850 bg-gray-125 p-4",
        className
      )}
    >
      <div className="flex items-center gap-4">
        <IconFactory type={IconTypeEnum.twinkle} />

        <p>本文由AI辅助翻译</p>
      </div>

      <ButtonFactory
        buttonType={ButtonType.Link}
        mask={ButtonType.Secondary}
        text="查看原文"
        className="bg-white"
        link={urlPath.replace("/zh-hans", "")}
        onClick={handleClick}
      />
    </div>
  );
};

export default ChineseBanner;
